<template>
  <main class="other_user_prof">
    <template v-if="!fetchingData">
      <section>
        <div class="back_btn" @click="goBack">
          <i class="fas fa-chevron-left"></i>
        </div>
        <h1>{{ getTranslations.home_rank_others_title }}</h1>
        <div class="user_prof_box">
          <div class="flex-row">
            <div class="user_img_bg">
              <img :src="userStats.avatar">
            </div>
            <div class="flex-column">
              <p class="country">{{ getGovernorateTranslation(userStats.governorate) }}</p>
              <p class="name">{{ userStats.username }}</p>
              <div class="flex-row points">
                <img src="/static/images/home/points_star.png" class="points_img_anim">
                <p>{{ userStats.totalPointsEarned }}</p>
              </div>
            </div>
          </div>
          <div class="lvl_title flex-row">
            <img src="/static/images/lvl_bar.png" class="lvl_icon">
            <p><b>{{ getTranslations.home_profile_level }} {{ userStats.level }}
              {{ getTranslations['home_profile_level_' + userStats.level] }}</b></p>
          </div>
        </div>
      </section>
      <section>
        <h2>{{ getTranslations.home_rank_others_performance }}</h2>
        <div class="stats_box">
          <div class="stats_row">
            <p class="title"> {{ getTranslations.home_profile_profile_points }} </p>
            <p class="numb">{{ userStats.totalPointsEarned }}</p>
          </div>
          <div class="stats_row">
            <p class="title"> {{ getTranslations.home_profile_profile_games }} </p>
            <p class="numb">{{ userStats.availableGames }}</p>
          </div>
          <div class="stats_row">
            <p class="title">{{ getTranslations.home_profile_completed_achievements }}</p>
            <p class="numb">{{ userStats.achievements }}</p>
          </div>
          <div class="stats_row">
            <p class="title">{{ getTranslations.home_profile_total_questions }}</p>
            <p class="numb">{{ distinguishedStats.questionsPlayed }}</p>
          </div>
          <div class="stats_row">
            <p class="title">{{ getTranslations.home_profile_wrong_questions }}</p>
            <p class="numb">{{ wrongQuestions }}</p>
          </div>
          <div class="stats_row">
            <p class="title">{{ getTranslations.home_profile_correct_questions }}</p>
            <p class="numb">{{ distinguishedStats.correctQuestions }}</p>
          </div>
          <div class="stats_row">
            <p class="title">{{ getTranslations.home_profile_accuracy_questions }}</p>
            <p class="numb">{{ accuracyQuestions }}</p>
          </div>

        </div>
      </section>
    </template>
  </main>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import {governorateTranslationMap} from "../../../constants/governorate";

export default {
  name: 'rank-user-stats',
  data() {
    return {
      fetchingData: true,
      localStorageRankUserPageInfo: null
    }
  },
  async created() {
    if (localStorage.getItem('rankUserPageInfo')) {
      this.localStorageRankUserPageInfo = JSON.parse(localStorage.getItem('rankUserPageInfo'))
      if (this.localStorageRankUserPageInfo) {
        await this.storeRankUserDetails(this.localStorageRankUserPageInfo.id)
      }
    }

    this.fetchingData = false
  },
  computed: {
    ...mapGetters('profile', [
      'getUserData'
    ]),
    ...mapGetters('i18n',[
      'getTranslations'
    ]),
    ...mapState('profile',[
      'distinguishedStats'
    ]),
    userStats() {
      return this.getUserData || {};
    },
    wrongQuestions() {
      return this.distinguishedStats.questionsPlayed - this.distinguishedStats.correctQuestions;
    },
    accuracyQuestions() {
      if (this.distinguishedStats.questionsPlayed === 0) {
        return '0%';
      }
      const accuracy = this.distinguishedStats.correctQuestions / this.distinguishedStats.questionsPlayed;
      return `${Math.ceil(accuracy * 100)}%`;
    }
  },
  methods: {
    ...mapActions('profile', [
      'storeRankUserDetails',
      'getUserAchievementsByMsisdn'
    ]),
    ...mapMutations('profile', [
      'setRankUserDetails'
    ]),
    goBack() {
      this.$router.replace({name: (this.localStorageRankUserPageInfo && this.localStorageRankUserPageInfo.prevPageName) || 'homeDefault'})
    },
    getGovernorateTranslation(governorateCode) {
      const translationKey = governorateTranslationMap[governorateCode];
      return this.getTranslations[translationKey] || governorateCode; // Fallback to the code if no translation found
    },
  },
  beforeRouteLeave (_to, _from, next) {
    if (this.localStorageRankUserPageInfo) {
      localStorage.removeItem('rankUserPageInfo')
    }

    this.setRankUserDetails({})

    next()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/RankUserStats.vue